var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaV1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 14.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 14.5,
    stroke: "#D3D3D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3867 29.8274L20.3104 18.2017H23.3868L21.462 29.8274H18.3867ZM32.6204 18.4883C32.0108 18.2523 31.0557 18 29.8629 18C26.8231 17.9996 24.6814 19.5767 24.6635 21.8365C24.6463 23.5064 26.1923 24.4387 27.3592 24.995C28.5567 25.5643 28.9594 25.9281 28.9536 26.437C28.946 27.2159 27.9972 27.5722 27.113 27.5722C25.8817 27.5722 25.2274 27.3961 24.217 26.962L23.8205 26.7769L23.3887 29.3795C24.1074 29.7042 25.436 29.9854 26.8156 30C30.0496 29.9998 32.1491 28.4414 32.173 26.0282C32.1846 24.7055 31.365 23.6993 29.5901 22.8695C28.5147 22.3314 27.8559 21.973 27.863 21.4283C27.863 20.945 28.4205 20.4284 29.6248 20.4284C30.6311 20.412 31.3596 20.6382 31.9274 20.8738L32.2033 21.0077L32.6204 18.4883ZM40.5096 18.2127H38.1322C37.3958 18.2127 36.8445 18.4202 36.5211 19.1772L31.9521 29.8308H35.1827C35.1827 29.8308 35.711 28.3986 35.8306 28.0841C36.1838 28.0841 39.322 28.0891 39.7707 28.0891C39.8628 28.496 40.145 29.831 40.145 29.831L43 29.8308L40.5096 18.2127ZM36.7158 25.7062C36.9703 25.0364 37.9415 22.4567 37.9415 22.4567C37.9235 22.4875 38.1939 21.7836 38.3494 21.3471L38.5576 22.3491C38.5576 22.3491 39.1464 25.1245 39.2695 25.7064L36.7158 25.7062ZM15.8064 18.2102L12.7945 26.1381L12.4735 24.5271C11.9128 22.6697 10.1656 20.6578 8.21246 19.6504L10.9667 29.8173L14.2218 29.8133L19.0653 18.2102H15.8064Z",
    fill: "#191E70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 18.2032H5.03924L5 18.4452C8.85959 19.4072 11.4133 21.733 12.4735 24.5271L11.3947 19.1849C11.2085 18.4487 10.6683 18.229 10.0002 18.2032Z",
    fill: "#F7B600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaV1);
export default __webpack_public_path__ + "static/media/visa-v1.06cd6246d5eb87f3b21baa22fa107009.svg";
export { ForwardRef as ReactComponent };